import Dialog from '@/components/dialog/Dialog';
import DialogHeader from '@/components/dialog/DialogHeader';
import { useModal } from '@ebay/nice-modal-react';
import { CardContext } from '../context/CardContext';
import { TripData } from '../engine/ConciergeCardViewModel';
import ConciergeCardInfo from './ConciergeCardInfo';

type Props = {
	selectedCard: TripData;
	onClose?: () => void;
};

const ConciergeRideDetailsDialog = ({ selectedCard, onClose }: Props) => {
	const modal = useModal();

	const handleHide = () => {
		onClose?.();
		modal.remove();
	};

	return (
		<Dialog
			className="x4b-concierge font-poppins"
			style={{ width: 'min(640px, calc(100vw - 48px))', maxHeight: 'calc(100vh - 48px)' }}
			header={<DialogHeader title="Ride details" />}
			visible={modal.visible}
			onHide={handleHide}
			pt={{
				content: () => ({ className: 'overflow-y-auto no-scrollbar' }),
			}}
		>
			<CardContext.Provider value={{ selectedCard, setSelectedCard: () => { } }}>
				<ConciergeCardInfo />
			</CardContext.Provider>
		</Dialog>
	);
};

export default ConciergeRideDetailsDialog;
